var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditImageIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.26178 0C8.04855 0 7.8353 0.0814323 7.67259 0.244141L6.66672 1.25L8.75007 3.33333L9.75594 2.32747C10.0814 2.00206 10.0814 1.47451 9.75594 1.14909L8.85098 0.244141C8.68827 0.0814323 8.47501 0 8.26178 0ZM5.83338 2.08333L0.941576 6.9751C0.941576 6.9751 1.32398 6.94083 1.46648 7.08333C1.60898 7.22583 1.49168 8.15833 1.66668 8.33333C1.84168 8.50833 2.76831 8.38515 2.90123 8.51807C3.03414 8.65098 3.02493 9.05843 3.02493 9.05843L7.91673 4.16667L5.83338 2.08333ZM0.41667 8.33333L0.0236004 9.44661C0.00814815 9.49055 0.000170766 9.53676 0 9.58333C0 9.69384 0.043899 9.79982 0.12204 9.87796C0.200181 9.9561 0.306162 10 0.41667 10C0.463242 9.99983 0.509456 9.99185 0.55339 9.9764C0.554749 9.97586 0.556105 9.97532 0.557459 9.97477L0.568038 9.97152C0.568854 9.97098 0.569668 9.97043 0.57048 9.96989L1.66668 9.58333L1.04167 8.95833L0.41667 8.33333Z",
    fill: "#7D54FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditImageIcons);
export default __webpack_public_path__ + "static/media/edit_image_icons.7f9172f213d6355e9286989aaa3adb62.svg";
export { ForwardRef as ReactComponent };